import $ from 'jquery';
import RequireLoginModal from 'desktop/components/require_login_modal';
import AhoyEvent from 'shared/ahoy_event';

export default class ButtonFollow {
  constructor({ element: element }) {
    this.element = element;
    this.componentId = this.id();
    $(this.element).attr('data-component-id', this.componentId);

    this.ui = {
      follow:       'a.button-follow',
      unfollow:     'a.button-follow.button-follow--following',
      requireLogin: 'a.button-follow[data-require-login="true"]',
      userId:       'a.button-follow[data-user-id="' + $(this.element).data('userId') + '"]',
      componentId:  'a.button-follow[data-component-id="'+ this.componentId + '"]',
    };

    this.names = {
      follow: 'button-follow',
      selfRemove:   'button-follow--self-remove',
      unfollow: 'button-follow--following'
    };
  }

  id() {
    return '_' + Math.random().toString(36).substr(2, 9);
  }

  init() {
    this.requireLoginModal = new RequireLoginModal({ element: this.element });
    this.bindAjaxBefore();
    this.bindAjaxSuccess();
  }

  bindAjaxSuccess(){
    $(document).on('ajax:success', this.ui.componentId, function(){
      this.toggle();
    }.bind(this));
  }

  bindAjaxBefore() {
    $(document).on('ajax:beforeSend', this.ui.componentId, function(e){
      if (this.isRequireLogin()) {
        this.requireLoginModal.onClick(e);
        e.preventDefault();
        return false;
      }

      return true;
    }.bind(this));
  }

  isRequireLogin(){
    return !window.isUserSignedIn;
  }

  isFollowing(){
    return $(this.element).hasClass(this.names.unfollow);
  }

  isSelfRemove(){
    return $(this.element).hasClass(this.names.selfRemove);
  }

  sendAhoy(){
    const ahoyProps = $(this.element).data('ahoyProps');
    if (ahoyProps === undefined){
      return false;
    }

    const props = this.insertAhoyPropsFeature(ahoyProps);
    AhoyEvent.send("VIDIO::SEARCH", props);
  }

  insertAhoyPropsFeature(props) {
    if(this.isFollowing()){
      props.feature = "user_follow";
    } else {
      props.feature = "user_unfollow";
    }

    return props;
  }

  toggle(){
    if (this.isSelfRemove()) {
      var elm = $(this.element).data('removeContainer');
      $(this.element).parents(elm).fadeOut();
      return;
    }

    if(this.isFollowing()){
      $(this.element).removeClass(this.names.unfollow);
      $(this.element).attr('href', $(this.element).data('followPath'));
      $('body').trigger('publish:unfollow');
    } else {
      $(this.element).addClass(this.names.unfollow);
      $(this.element).attr('href', $(this.element).data('unfollowPath'));
      $('body').trigger('publish:follow');
    }

    this.sendAhoy();
  }
}
